import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://api.sharkfragrance.com/payouts';

export const fetchPayouts = createAsyncThunk('payouts/fetchPayouts', async (bdeId, { rejectWithValue }) => {
  try {
    const url = bdeId ? `${API_URL}/${bdeId}` : API_URL;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const addPayout = createAsyncThunk('payouts/addPayout', async (payoutData, { rejectWithValue }) => {
  try {
    const response = await axios.post(API_URL, payoutData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const updatePayout = createAsyncThunk('payouts/updatePayout', async ({ id, ...data }, { rejectWithValue }) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const deletePayout = createAsyncThunk('payouts/deletePayout', async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`${API_URL}/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

const payoutsSlice = createSlice({
  name: 'payouts',
  initialState: {
    payouts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayouts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPayouts.fulfilled, (state, action) => {
        state.loading = false;
        state.payouts = action.payload;
      })
      .addCase(fetchPayouts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addPayout.fulfilled, (state, action) => {
        state.payouts.unshift(action.payload);
      })
      .addCase(updatePayout.fulfilled, (state, action) => {
        const index = state.payouts.findIndex(p => p._id === action.payload._id);
        if (index !== -1) {
          state.payouts[index] = action.payload;
        }
      })
      .addCase(deletePayout.fulfilled, (state, action) => {
        state.payouts = state.payouts.filter(p => p._id !== action.payload);
      });
  },
});

export default payoutsSlice.reducer;
